import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=2ae35730&scoped=true&"
import script from "./CustomLink.vue?vue&type=script&lang=js&"
export * from "./CustomLink.vue?vue&type=script&lang=js&"
import style0 from "./CustomLink.vue?vue&type=style&index=0&id=2ae35730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae35730",
  null
  
)

export default component.exports